import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SignupResetService } from '../signup-reset.service';
import { SignupSubmitService } from '../intake/signup-submit.service';
import { ENROLLED_STATE } from '../submitted/submitted-signup.service';

/**
 * /enrolled is the thank-you page for an intake (enrollment or waitlist) submitted in this visit, or its history
 * entry (Back/Forward to it, or a reload: the router restores the entry's state). Without either (e.g. opened
 * directly) it goes to the landing page, like /signup without an address: not the app root, which is /login for a
 * logged-out visitor.
 */
export const enrolledGuard: CanActivateFn = () => {
  const router = inject(Router);
  if (inject(SignupSubmitService).isSubmitted() || router.currentNavigation()?.extras.state?.[ENROLLED_STATE] === true) {
    return true;
  }
  inject(SignupResetService).exitToLanding();
  return false;
};
